<template>
  <div class="px-4 bg-light">
    <div class="py-4 d-flex flex-wrap">
      <Button id="mk-suggestion" 
              v-for="(item, i) in items"
              :key="i"
              :label="item.label"
              class="mr-2 mb-2"
              outline
              @click="onClick(item)"/>
    </div>
  </div>
</template>

<script>
  import Button from 'components/Button';
  import {mapState, mapActions} from 'vuex';

  export default {
    name: 'QuickReplies',
    components: {
      Button
    },
    props: {
      show: Boolean
    },
    computed: {
      ...mapState({
        items: state => state.quickReplies.items
      })
    },
    methods: {
      ...mapActions(['sendMessage', 'toggleQuickReplies']),
      async onClick(item) {
        this.sendMessage(item.value);
        this.toggleQuickReplies();
      }
    }
  }
</script>
